// extracted by mini-css-extract-plugin
export default {"field":"field--17d528","field__label":"field__label--3fa327","field__box":"field__box--09ddce"};